import { render, staticRenderFns } from "./SuburbReport.vue?vue&type=template&id=f2a64a12&scoped=true&"
import script from "./SuburbReport.vue?vue&type=script&lang=ts&"
export * from "./SuburbReport.vue?vue&type=script&lang=ts&"
import style0 from "./SuburbReport.vue?vue&type=style&index=0&id=f2a64a12&scoped=true&lang=css&"
import style1 from "./SuburbReport.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a64a12",
  null
  
)

export default component.exports